import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-agent-listing-item',
  templateUrl: './agent-listing-item.component.html',
  styleUrls: ['./agent-listing-item.component.css']
})
export class AgentListingItemComponent implements OnInit {

  @Input() listing;

  constructor() { }

  ngOnInit(): void {
  }

}
